import React from "react";
import { Row, Col, FormGroup, Label } from "reactstrap";
import { Field } from "formik";
import {
  CreditCard,
  RefreshCw,
  Lock,
  Unlock,
  Trash2,
  Plus,
} from "lucide-react";

const MembershipCardSection = ({
  values,
  RFIDCardId,
  allowFreezeCardAction,
  allowDeleteCardAction,
  dispatch,
  setMembershipCardsScannerPopupOpen,
  setConfirmModal,
  confirmModal,
  freezeMembershipCard,
  unfreezeMembershipCard,
  deleteMembershipCard,
  setRFIDCardIdValue,
}) => {
  const hasCard = !!values.cardMembershipId;
  const isCardActive = values.cardMembershipStatus === "ACTIVE";

  return (
    <div
      style={{
        background: "#f8f9fa",
        border: "1px solid #dee2e6",
        borderRadius: "12px",
        padding: "20px",
        marginTop: "16px",
        marginBottom: "16px",
      }}
    >
      {/* Card Header */}
      <div style={{ marginBottom: "16px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          <CreditCard size={24} color="#495057" />
          <h4
            style={{
              color: "#212529",
              margin: 0,
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            Membership Card
          </h4>
          {hasCard && (
            <div
              style={{
                display: "inline-block",
                padding: "4px 12px",
                borderRadius: "20px",
                background: isCardActive
                  ? "rgba(16, 185, 129, 0.2)"
                  : "rgba(239, 68, 68, 0.2)",
                border: `1px solid ${isCardActive ? "#10b981" : "#ef4444"}`,
              }}
            >
              <span
                style={{
                  color: isCardActive ? "#10b981" : "#ef4444",
                  fontSize: "11px",
                  fontWeight: "600",
                  textTransform: "uppercase",
                }}
              >
                {isCardActive ? "● Active" : "● Frozen"}
              </span>
            </div>
          )}
        </div>
      </div>
      {console.log({ values, RFIDCardId })}
      {/* Card Number + Action Buttons */}
      <Row className="g-3">
        {/* Card Number Field */}
        <Col md={6}>
          <FormGroup className="custom-inputs mb-md-0 mt-5">
            <Field
              type="text"
              name="RFIDCardIdField"
              id="RFIDCardIdField"
              disabled={true}
              value={
                values.cardMembershipId ||
                values.RFIDCardIdField ||
                RFIDCardId ||
                ""
              }
              className={`form-control ${
                !(
                  values.cardMembershipId ||
                  values.RFIDCardIdField ||
                  RFIDCardId
                ) && !values?.id
                  ? "is-invalid"
                  : ""
              }`}
            />
            {!(
              values.cardMembershipId ||
              values.RFIDCardIdField ||
              RFIDCardId
            ) && !values?.id && (
              <div className="invalid-feedback">
                Membership Card is required
              </div>
            )}
            <Label for="RFIDCardIdField">Membership Card Number</Label>
          </FormGroup>
        </Col>

        {/* Action Buttons */}
        <Col md={6} className="mt-5 d-flex flex-wrap gap-2">
          {values.cardMembershipId && values?.id ? (
            <>
              {/* Replace Card */}
              <button
                type="button"
                onClick={() =>
                  dispatch(setMembershipCardsScannerPopupOpen(true, "replace"))
                }
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "10px 18px",
                  background: "white",
                  color: "#667eea",
                  border: "2px solid #667eea",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  whiteSpace: "nowrap",
                  marginRight: "8px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "#667eea";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "white";
                  e.target.style.color = "#667eea";
                }}
              >
                <RefreshCw size={16} /> Replace Card
              </button>

              {/* Freeze/Unfreeze */}
              {allowFreezeCardAction && (
                <button
                  type="button"
                  onClick={() => {
                    setConfirmModal({
                      confirmModalOpen: true,
                      title: `${
                        isCardActive ? "Freeze" : "Unfreeze"
                      } Membership Card`,
                      message: `Are you sure you want to ${
                        isCardActive ? "freeze" : "unfreeze"
                      } this membership card?`,
                      confirmButtonText: isCardActive ? "Freeze" : "Unfreeze",
                      setConfirmModalOpen: () =>
                        setConfirmModal({
                          ...confirmModal,
                          confirmModalOpen: false,
                        }),
                      confirmHandler: () => {
                        if (isCardActive) {
                          dispatch(
                            freezeMembershipCard(values.cardMembershipId)
                          );
                        } else {
                          dispatch(
                            unfreezeMembershipCard(values.cardMembershipId)
                          );
                        }
                      },
                    });
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "10px 18px",
                    background: isCardActive
                      ? "rgba(239, 68, 68, 0.1)"
                      : "rgba(16, 185, 129, 0.1)",
                    color: isCardActive ? "#dc2626" : "#059669",
                    border: `2px solid ${isCardActive ? "#dc2626" : "#059669"}`,
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    whiteSpace: "nowrap",
                    marginRight: "8px",
                  }}
                  onMouseEnter={(e) => {
                    if (isCardActive) {
                      e.target.style.background = "#dc2626";
                      e.target.style.color = "white";
                    } else {
                      e.target.style.background = "#059669";
                      e.target.style.color = "white";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = isCardActive
                      ? "rgba(239, 68, 68, 0.1)"
                      : "rgba(16, 185, 129, 0.1)";
                    e.target.style.color = isCardActive ? "#dc2626" : "#059669";
                  }}
                >
                  {isCardActive ? <Lock size={16} /> : <Unlock size={16} />}
                  {isCardActive ? "Freeze Card" : "Unfreeze Card"}
                </button>
              )}

              {/* Delete Card */}
              {allowDeleteCardAction && (
                <button
                  type="button"
                  onClick={() => {
                    setConfirmModal({
                      confirmModalOpen: true,
                      title: "Delete Membership Card",
                      message:
                        "Are you sure you want to delete this membership card? This action removes it from all branches.",
                      confirmButtonText: "Delete",
                      setConfirmModalOpen: () =>
                        setConfirmModal({
                          ...confirmModal,
                          confirmModalOpen: false,
                        }),
                      confirmHandler: () =>
                        dispatch(deleteMembershipCard(values.cardMembershipId)),
                    });
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "10px 18px",
                    background: "rgba(239, 68, 68, 0.1)",
                    color: "#dc2626",
                    border: "2px solid #dc2626",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    whiteSpace: "nowrap",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#dc2626";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "rgba(239, 68, 68, 0.1)";
                    e.target.style.color = "#dc2626";
                  }}
                >
                  <Trash2 size={16} /> Delete Card
                </button>
              )}
            </>
          ) : (
            <>
              {/* Add Membership Card */}
              <button
                type="button"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "15px 10px",
                  background: "white",
                  color: "#667eea",
                  border: "2px solid #667eea",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  height: "54px",
                  marginRight: "8px",
                }}
                onClick={() =>
                  dispatch(setMembershipCardsScannerPopupOpen(true, values?.id?"addCardForExistingMember":"add"))
                }
                onMouseEnter={(e) => {
                  e.target.style.background = "#667eea";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "white";
                  e.target.style.color = "#667eea";
                }}
              >
                <Plus size={16} /> Add Card
              </button>

              {/* Reset Card if RFIDCardId exists */}
              {RFIDCardId &&!values?.id&& (
                <button
                  type="button"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "15px 10px",
                    background: "white",
                    color: "#ef4444",
                    border: "2px solid #ef4444",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => dispatch(setRFIDCardIdValue(""))}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#ef4444";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "white";
                    e.target.style.color = "#ef4444";
                  }}
                >
                  Reset Card
                </button>
              )}
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MembershipCardSection;
